<template>
    <div class="rounded-lg shadow-lg bg-white px-4 md:px-6 py-4 my-2">
        <div class="flex flex-col gap-4">
            <div v-on:click="open = !open" class="flex flex-row justify-between items-center gap-4 md:gap-8 grow-0 cursor-pointer">
                <h1 v-if="headlineNumber === 1" v-html="title" class="base_bold no"></h1>
                <h2 v-else-if="headlineNumber === 2" class="base_bold no" v-html="title"></h2>
                <h3 v-else-if="headlineNumber === 3" class="base_bold no" v-html="title"></h3>
                <h4 v-else-if="headlineNumber === 4" class="base_bold no" v-html="title"></h4>
                <h5 v-else-if="headlineNumber === 5" class="base_bold no" v-html="title"></h5>
                <h6 v-else class="base_bold no" v-html="title"></h6>

                <!-- {{ title }} -->
                <button class="w-10 h-10 bg-blue-light rounded-full shrink-0 relative">
                    <div class="top-0 bottom-0 left-0 right-0 m-auto w-6 h-[2px] bg-blue-dark absolute" :class="open ? 'hidden' : 'block'"></div>
                    <div
                        class="top-0 bottom-0 left-0 right-0 m-auto w-6 h-[2px] bg-blue-dark absolute transform transition-all ease-in-out"
                        :class="open ? 'rotate-0' : 'rotate-90'"
                    ></div>
                </button>
            </div>
            <TransitionExpand v-show="open">
                <div>
                    <hr />
                    <div :class="inner_class" v-html="content"></div>
                </div>
            </TransitionExpand>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        open: false
    }),
    props: {
        title: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: true
        },
        inner_class: {
            type: String,
            default: 'mt-6 max-w-4xl'
        },
        headlineNumber: {
            type: Number,
            default: 3
        }
    },
    methods: {}
};
</script>
